module.exports = __webpack_public_path__ + "b3e677e266e4842a2418568beeb74033.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/ppu.jpg
 ** module id = 472
 ** module chunks = 0
 **/